import { render, staticRenderFns } from "./BeautyNailsDataSheet.vue?vue&type=template&id=3dde13c2&scoped=true"
import script from "./BeautyNailsDataSheet.vue?vue&type=script&lang=js"
export * from "./BeautyNailsDataSheet.vue?vue&type=script&lang=js"
import style0 from "./BeautyNailsDataSheet.vue?vue&type=style&index=0&id=3dde13c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde13c2",
  null
  
)

export default component.exports